import { Outlet } from 'react-router-dom'
import LottomdHeader from './LottomdHeader'
import LottomdFooter from './LottomdFooter'

export default function LottomdLayout() {
  return (
    <div className="md-site">
      <LottomdHeader />
      <main id="main-content" className="md-main" tabIndex={-1}>
        <Outlet />
      </main>
      <LottomdFooter />
    </div>
  )
}
